var $b61325f242fafc7c$exports = {};
$b61325f242fafc7c$exports = {
  "colorInputLabel": function colorInputLabel(args) {
    return "".concat(args.label, ", ").concat(args.channelLabel);
  },
  "colorNameAndValue": function colorNameAndValue(args) {
    return "".concat(args.name, ": ").concat(args.value);
  },
  "colorPicker": "V\xFDber farieb",
  "colorSwatch": "vzorkovn\xEDk farieb",
  "transparent": "transparentn\xFD",
  "twoDimensionalSlider": "2D jazdec"
};
export { $b61325f242fafc7c$exports as default };